<template>
  <div class="row">
    <div class="col-12">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Description</th>
            <th scope="col">Type</th>
            <th scope="col">Status</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <draggable
          :list="newItems"
          tag="tbody"
          ghost-class="ghost"
          @change="checkMove"
          v-if="newItems.length > 0 && !loaders.page"
        >
          <tr v-for="(item, i) in newItems" :key="i">
            <td scope="row">
              <img
                src="~@/assets/media/icons/draggable.svg"
                class="mr-1 icon"
                alt="draggable icon"
              />
              {{ item.name }}
            </td>
            <td @click="toggleDescription(item._id)">
              <span v-if="toggledDescription === item._id">{{
                item.description
              }}</span>
              <span v-else>{{
                item.description && item.description.length >= 80
                  ? item.description.slice(0, 80) + "..."
                  : item.description
              }}</span>
            </td>
            <td>{{ categoryType(item.type) }}</td>
            <td>
              <template>
                <span v-if="item.status == 0" class="text-danger">
                  Draft
                </span>
                <span v-else-if="item.status == 1" class="text-warning">
                  Private
                </span>
                <span v-else class="text-success">Public</span>
              </template>
            </td>
            <td class="table__content-action">
              <action-button
                label=""
                style="margin-right: 15px; margin-top: 0;"
                @customEvent="handleClickEdit(item)"
              >
                <img
                  src="~@/assets/media/icons/create-light.svg"
                  alt="edit icon"
                />
              </action-button>
              <action-button
                label=""
                class="btn-danger"
                style="margin-right: 0; margin-top: 0;"
                @customEvent="handleClickDelete(item)"
              >
                <FetchingOverlay v-if="loaders.deleteButton === item._id" />
                <span v-else>
                  &mdash;
                </span>
              </action-button>
            </td>
          </tr>
        </draggable>

        <tr v-else-if="loaders.page">
          <td colspan="5">
            <Spinner :theme="primary" />
          </td>
        </tr>
        <tr v-else>
          <td colspan="5">
            No Categories found...
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { categories } from "../../helpers/table-headers";
import { socketSender } from "@/helpers/socket";
import { mapActions } from "vuex";
import types from "@/variables/types";
import axios from "@/helpers/axios";
import _ from "lodash";
import Spinner from "@/components/Spinner";

const FetchingOverlay = () => import("@/components/FetchingOverlay");
const draggable = () => import("vuedraggable");
const ActionButton = () => import("@/components/ActionButton");

export default {
  components: {
    ActionButton,
    FetchingOverlay,
    draggable,
    Spinner
  },
  data: () => ({
    tableHeader: [],
    toggledDescription: null,
    api: {
      page: 1,
      size: 9999999,
      action: "orderBy=order:ASC,createdAt:DESC"
    },
    loaders: {
      page: true,
      deleteButton: -1
    },
    newItems: [],
    order: []
  }),
  created() {
    this.init();
  },
  watch: {
    items() {
      this.handleNewItems();
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    user() {
      return this.$store.getters.getFullUser;
    },
    items() {
      return this.$store.state.admin.collection;
    }
  },
  methods: {
    ...mapActions({
      FETCH_COLLECTION_PER_PAGE: "FETCH_COLLECTION_PER_PAGE"
    }),
    async init() {
      this.tableHeader = categories;
      await this.handleReloadPage();
    },
    categoryType(type) {
      const ctype = _.find(types.categoryType, { value: type });
      return ctype ? ctype.label : "";
    },
    handleClickEdit(item) {
      const { page, size, action } = this.api;
      this.$emit("edit", {
        singleRecord: item,
        link: this.pagelink(page, size, action)
      });
    },
    async handleClickDelete(item) {
      this.loaders.deleteButton = item._id;
      const orders = await axios
        .get(`/categories/${item._id}/products`)
        .then(result => {
          const { data } = result.data;
          return data.Products || [];
        });

      this.loaders.deleteButton = -1;
      if (orders.length === 0) {
        this.$swal({
          title: "Are you sure to remove this data",
          type: "warning",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true
        }).then(async result => {
          if (result.value) {
            await axios.delete(`/categories/${item._id}`);
            socketSender(
              "updateLog",
              `${this.user} removed the package named ${item.name}`
            );
            await this.handleReloadPage();
          }
        });
      } else {
        this.$swal({
          title:
            "Can't delete this package entry since it is associated with active records.",
          type: "error"
        });
      }
    },
    async handleReloadPage() {
      const { page, size, action } = this.api;
      await this.FETCH_COLLECTION_PER_PAGE(this.pagelink(page, size, action));
      this.loaders.page = false;
    },
    async handleNextPage() {
      this.api.page += 1;
      this.loaders.page = true;
      await this.handleReloadPage();
    },
    async handlePrevPage() {
      this.api.page -= 1;
      this.loaders.page = true;
      await this.handleReloadPage();
    },
    pagelink(page, size = 10, action = "") {
      return `/categories?page[number]=${page}&page[size]=${size}&${action}`;
    },
    toggleDescription(id) {
      if ((this.toggledDescription && !id) || this.toggledDescription === id) {
        this.toggledDescription = null;
      } else {
        this.toggledDescription = id;
      }
    },
    async checkMove() {
      for (let i = 0; i < this.newItems.length; i++) {
        let form = {};
        form = {
          order: i
        };
        if (this.order[i].order == 0) {
          await axios
            .patch(`/categories/${this.newItems[i]._id}`, form)
            .then(() => {
              this.order[i].id = this.newItems[i].id;
            });
        } else if (this.order[i].order != this.newItems[i].id) {
          await axios
            .patch(`/categories/${this.newItems[i]._id}`, form)
            .then(() => {
              this.order[i].id = this.newItems[i].id;
            });
        }
      }
    },
    handleNewItems() {
      var data = this.items;
      var order = [];
      order = data.map((result, i) => ({
        id: i,
        order: result.order
      }));
      data = data.map((result, i) => ({
        name: result.name,
        _id: result.id,
        id: i,
        description: result.description,
        type: result.type,
        status: result.status
      }));
      this.order = order;
      this.newItems = data;
    }
  }
};
</script>

<style lang="scss" scoped>
.table {
  tr {
    background-color: #fafafa;
    cursor: move;
    td {
      font-size: 0.75rem;
      font-family: "Gotham Book";
      .icon {
        width: 14.5px;
      }
    }
  }
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb !important;
}
</style>
